import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import {
  AutenticacaoContainer,
  Botao,
  Breadcrumb,
  Cabecalho,
  ContainerAcoes,
  Filtro,
  IconeEditar,
  TabelaDados,
  TabelaRef,
  TabelaResposta,
  Tooltip,
  Visao
} from 'src/componentes'
import {
  Container,
  Form,
  ContainerDados75,
  Dados
} from 'src/componentes/styles/filtro'
import {
  DataInputUnform,
  InputUnform,
  SelectOpcao,
  SelectUnform
} from 'src/componentes/unform'
import { RotasTurmaCertificacao, RotasProfessorCertificacao } from 'src/rotas'
import { Api } from 'src/servicos'
import { TipoOrdenacao } from 'src/tipos'
import {
  AlunoCertificacaoSituacao,
  DadosPesquisaProfessorCertificacao
} from 'src/tipos/aluno-certificacao'

import { ContainerCertificacao } from '../styles'
import { TabelaComEstilos } from './styles'

export const PaginaProfessoresCertificacao: React.FC = () => {
  const { visao } = AutenticacaoContainer.useContainer()
  const usuario = localStorage.getItem('@ipgs/usuario')
  const usuarioObj = JSON.parse(usuario)
  const usuarioId = usuarioObj.id

  const history = useHistory()
  const [
    dadosPesquisa,
    definirDadosPesquisa
  ] = useState<DadosPesquisaProfessorCertificacao>(null)
  const tabelaRef = useRef<TabelaRef>()
  const [paginas, definirPaginas] = useState(null)
  const [usuarioOpcoes, definirUsuarioOpcoes] = useState<SelectOpcao[]>([])

  const obterDados = async (
    numeroPaginas: number,
    quantidadePorPagina: number,
    chaveOrdenacao?: string,
    ordem?: TipoOrdenacao
  ): Promise<TabelaResposta | null> => {
    if (paginas !== null) {
      numeroPaginas = paginas
    }

    const parametrosComuns = {
      usuarioId,
      visao,
      cpf: dadosPesquisa?.cpf,
      nome: dadosPesquisa?.nome,
      email: dadosPesquisa?.email,
      usuarioPerfilFiltro: dadosPesquisa?.usuarioPerfilFiltro,
      dataCriacaoProfessor: dadosPesquisa?.dataCriacaoProfessor,
      chaveOrdenacao,
      ordem
    }

    const requisitarProfessores = async (
      pagina: number,
      quantidade: number,
      isPaginated: number
    ) =>
      Api.RequisitarListaProfessoresCertificacao(
        parametrosComuns.usuarioId,
        parametrosComuns.visao,
        isPaginated,
        dadosPesquisa?.cpf,
        parametrosComuns.nome,
        dadosPesquisa?.email,
        parametrosComuns.usuarioPerfilFiltro,
        parametrosComuns?.dataCriacaoProfessor,
        pagina,
        quantidade,
        parametrosComuns.chaveOrdenacao,
        parametrosComuns.ordem
      )

    const dados = await requisitarProfessores(
      numeroPaginas,
      quantidadePorPagina,
      1
    )
    if (!dados) return null

    if (visao !== Visao.ParceiroCertificacao) {
      const dadosTodos = await requisitarProfessores(1, 0, 0)
      const usuariosUnicos = dadosTodos.registros
        .map(dado => ({
          id: dado.usuarioPerfilId,
          texto: dado.usuarioPerfilNome
        }))
        .filter(
          (valor, indice, self) =>
            self.findIndex(v => v.id === valor.id) === indice
        )

      definirUsuarioOpcoes([{ id: '', texto: 'Todos' }, ...usuariosUnicos])
    }

    definirPaginas(null)

    return {
      Dados: dados.registros,
      Paginacao: {
        Pagina: dados.opcoesPaginacao.pagina,
        TotalRegistros: dados.opcoesPaginacao.totalRegistros
      }
    } as TabelaResposta
  }

  useEffect(() => {
    if (dadosPesquisa === null) return
    tabelaRef.current.IrParaPagina()
    tabelaRef.current.CarregarDados()
  }, [dadosPesquisa])

  const acaoPesquisa = (dados: DadosPesquisaProfessorCertificacao) => {
    if (dados !== null && paginas !== 1) {
      definirPaginas(1)
    }
    definirDadosPesquisa(dados)
  }

  return (
    <ContainerCertificacao>
      <Cabecalho>
        <Breadcrumb
          titulo="Pesquisa de Professores"
          atalhos={[
            {
              texto: 'Acadêmico'
            },
            {
              texto: 'Professores'
            }
          ]}
        />
        {visao === Visao.ParceiroCertificacao && (
          <Botao
            type="button"
            texto="Incluir"
            tema="Secundario"
            onClick={() => history.push(RotasProfessorCertificacao.Cadastro)}
          />
        )}
      </Cabecalho>
      <Filtro>
        <Form
          dadosIniciais={{
            situacao:
              AlunoCertificacaoSituacao[AlunoCertificacaoSituacao.Todos],
            modalidade: 'Todas'
          }}
          acaoSucesso={acaoPesquisa}
        >
          <Container>
            <ContainerDados75>
              <InputUnform type="text" name="nome" label="Nome" />
            </ContainerDados75>
            <ContainerDados75>
              <InputUnform type="text" name="cpf" label="CPF" />
            </ContainerDados75>
            {visao === Visao.ParceiroCertificacao && (
              <ContainerDados75>
                <DataInputUnform
                  name="dataCriacaoProfessor"
                  label="Data de criação"
                />
              </ContainerDados75>
            )}
          </Container>
          <Container>
            {/* <ContainerDados75>
              <InputUnform type="text" name="email" label="Email" />
            </ContainerDados75> */}
            {visao !== Visao.ParceiroCertificacao && (
              <>
                <ContainerDados75>
                  <SelectUnform
                    id="slct_usuario"
                    name="usuarioPerfilFiltro"
                    label="Parceiro"
                    margemInferior={false}
                    opcoes={usuarioOpcoes}
                  />
                </ContainerDados75>
                <ContainerDados75>
                  <DataInputUnform
                    name="dataCriacaoProfessor"
                    label="Data de criação"
                  />
                </ContainerDados75>
              </>
            )}
          </Container>
          <Botao
            type="submit"
            id="btn-aplicar-filtro"
            texto="Aplicar filtro"
            tema="Link"
          />
        </Form>
      </Filtro>
      <Dados>
        <TabelaComEstilos
          ref={tabelaRef}
          Colunas={[
            {
              Chave: 'cpf',
              Texto: 'CPF',
              ComOrdenacao: true
            },
            {
              Chave: 'nome',
              Texto: 'Nome',
              ComOrdenacao: true
            },
            // {
            //   Chave: 'email',
            //   Texto: 'Email',
            //   ComOrdenacao: true
            // },
            // {
            //   Chave: 'aptidoes',
            //   Texto: 'Aptidões',
            //   ComOrdenacao: true
            // },
            // {
            //   Chave: 'turma',
            //   Texto: 'Turma',
            //   Renderizar: (linha: any) => linha.turmaAluno?.nome ?? '-',
            //   ComOrdenacao: true
            // },
            // {
            //   Chave: 'situacao',
            //   Texto: 'Situação',
            //   ComOrdenacao: true
            // },
            ...(visao !== Visao.ParceiroCertificacao
              ? [
                  {
                    Chave: 'usuarioPerfilNome',
                    Texto: 'Nome do parceiro',
                    ComOrdenacao: false
                  }
                ]
              : []),
            {
              Chave: 'acoes',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => (
                <ContainerAcoes>
                  <button
                    type="button"
                    data-tip="Editar"
                    data-for={`${linha.id}-tooltip-editar`}
                    onClick={() =>
                      history.push(
                        `${RotasProfessorCertificacao.Edicao}/${linha.id}`,
                        {
                          modalidade: linha.modalidade
                        }
                      )
                    }
                    onContextMenu={() => {
                      const rota = window.open(
                        `${RotasTurmaCertificacao.Edicao}/${linha.id}/${linha.modalidade}`
                      )
                      rota.focus()
                    }}
                  >
                    {IconeEditar}
                  </button>
                  <Tooltip
                    id={`${linha.id}-tooltip-editar`}
                    place="bottom"
                    offset={{ top: 10 }}
                  />
                </ContainerAcoes>
              )
            }
          ]}
          ObterDados={obterDados}
          ComPaginacao
        />
      </Dados>
    </ContainerCertificacao>
  )
}

export { default as PaginaCadastroProfessoresCertificacao } from './cadastro'
